import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Tailoring.css";
import { LogIn } from "lucide-react";

const ApproveCertificate = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState(""); 
  const [viewdatas, setViewdatas] = useState(null);
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [resubmit,setResubmit]=useState(false);
  const [approve,setApprove]=useState(false)
  
  const recordsPerPage = 20;
 const [approvefile, setApprovefile] = useState(null);

  const [inputValue, setInputValue] = useState("");

  // Handle input change
  const handleChangeResubmit = (event) => {
    setInputValue(event.target.value);
  };

  // Handle submit button click
  const handleUpdateSubmit = async (id,inputValue ) => {
    // if (!inputValue || inputValue.trim() === "") {
    //   alert("Please enter a value before submitting.");
    //   return;
    // }
    // const input =inputValue
    if (inputValue===""){
      alert("Please enter a value before submitting.");
         return;
      
    }
  
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/tailoring/updateapprove/${id}`,
        { description: inputValue,status: "Re Submit"}
      );
  
      if (response.status === 200) {
        alert("User description updated successfully!");
        setInputValue('')
        fetchUsers();
        setView(false);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error updating user.");
    }
  };
  
  

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/tailoring/getUsers`);
      const filterdata = response.data.filter(
        (user) => user.status === "Pending" && user.description === ''
      );

     
      setUsers(filterdata);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleResubmit = (id) => {
    setResubmit(!resubmit)
  };

  const handleView = async (id) => {
    try {
      const getvalue = await axios.get(`${process.env.REACT_APP_API}/tailoring/getuser/${id}`);
      setViewdatas(getvalue.data);
      setView(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  // const handleUpdate = async (id, approvefile) => {


    
  //   try {
  //     const response = await axios.put(
  //       `${process.env.REACT_APP_API}/tailoring/updateapprove/${id}`,
  //       { status: "Approved" } // Now updating status only
  //     );
  
  //     if (response.status === 200) {
  //       alert("User status updated successfully!");
  //       fetchUsers();
  //       setView(false);
  //     }
  //   } catch (error) {
  //     console.error("Error updating user:", error);
  //     alert("Error updating user.");
  //   }
  // };
  
  const handleUpdate = async (id, approvefile) => {
    if (!approvefile) {
      alert("Please select a PDF file before submitting.");
      return;
    }
     console.log(approvefile);
    const formData = new FormData();
    formData.append("approveFile", approvefile);
    formData.append("status", "Approved");
   
    try {
      
      
      const response = await axios.put(
        `${process.env.REACT_APP_API}/tailoring/updateapprove/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        alert("User status and certificate uploaded successfully!");
        fetchUsers();
        setView(false);
        setApprove(false);
        setApprovefile(null);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Error updating user.");
    }
  };
  // Filter data based on search input
  const filteredData = users.filter((user) =>
    user.name.toLowerCase().includes(search.toLowerCase())
  );

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  // Get users for current page
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <div className="approve-certificate-container">
      <div className="approve-certificate-wrapper">
        <h2 className="text-center">Approve Certificate</h2>
        <input
          className="search-input"
          type="text"
          placeholder="Search by name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <table>
          <thead>
            <tr>
              <th>S No</th>
              <th>Name</th>
              <th>Course Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRecords.map((user, index) => (
              <tr key={user.id}>
                <td>{indexOfFirstRecord + index + 1}</td>
                <td>{user.name}</td>
                <td>{user.courseName}</td>
                <td className="status" >{user.status || "Pending"}</td>
                <td className="action-buttons">
                  {/* <button className="approved-btn" onClick={() => handleUpdate(user.id, user.status)} style={{marginRight:'5px'}}>
                    Approve
                  </button> */}
                  <button className="view-btn" onClick={() => handleView(user.id)}>
                       service status
                  </button>
                  {/* <button className="resubmit-btn" onClick={() => handleResubmit(user.id)}>
                    Resubmit
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <div className="pagination-controls">
          <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
            Next
          </button>
          
        </div>
      </div>
      {view && (
  <div className="overlay">
    <div className="popup">
      <div className="popup-header">
        <h2 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold" }}>
          View Tailoring User
        </h2>
        <button className="close-btn" onClick={() => setView(false)}>X</button>
      </div>

      <div className="popup-body">
        <div className="view-grid">
          <div className="view-item">
            <strong>Name:</strong> {viewdatas?.name}
          </div>
          <div className="view-item">
            <strong>Significant:</strong> {viewdatas?.significant}
          </div>
          <div className="view-item">
            <strong>Father/Husband Name:</strong> {viewdatas?.fatherHusbandName}
          </div>
          <div className="view-item">
            <strong>Address 1:</strong> {viewdatas?.address1}
          </div>
          <div className="view-item">
            <strong>Address 2:</strong> {viewdatas?.address2}
          </div>
          <div className="view-item">
            <strong>Pin Code:</strong> {viewdatas?.pinCode}
          </div>
          <div className="view-item">
            <strong>Aadhar Number:</strong> {viewdatas?.aadharNumber}
          </div>
          <div className="view-item">
            <strong>District:</strong> {viewdatas?.district}
          </div>
          <div className="view-item">
            <strong>Taluk:</strong> {viewdatas?.taluk}
          </div>
          <div className="view-item">
            <strong>Course Name:</strong> {viewdatas?.courseName}
          </div>
          <div className="view-item">
            <strong>Photo:</strong>
            <br />
            {viewdatas?.photo ? (
              <img 
                src={`${process.env.REACT_APP_API}/uploads/Categories/${viewdatas?.photo}`} 
                alt="User" 
                className="user-photo"
              />
            ) : (
              "No Photo Available"
            )}
          </div>
        </div>
      </div>
      {resubmit && (
        <div className="resubmit_div show">
          <input
            type="text"
            value={inputValue}
            onChange={handleChangeResubmit}
            placeholder="Enter text..."
          />
          <button onClick={()=>handleUpdateSubmit(viewdatas.id,inputValue)}>Submit</button>
        </div>
      )}

       {
        approve&&(
        <div className="resubmit_div show">
  <input
    type="file"
    accept="application/pdf"
    onChange={(e) => setApprovefile(e.target.files[0])}
    className="inputStyle"
  />
  <button onClick={() => handleUpdate(viewdatas.id, approvefile)}>Submit</button>
</div>

        )
       }
      
      <div className="popup-footer" >
      {/* <button className="approved-btn" onClick={() => handleUpdate(viewdatas.id,viewdatas.status)} style={{marginRight:'5px'}}>
                    Approve
                  </button> */}
                  {/* < button className="approved-btn" onClick={() => handleUpdate(viewdatas.id,viewdatas.status)} style={{marginRight:'5px'}}> */}
                  < button className="approved-btn" 
                  // onClick={() => handleUpdate(viewdatas.id,viewdatas.status)} 
                  onClick={()=>setApprove(!approve)}
                  style={{marginRight:'5px'}}>
                    Approve
                  </button>
                  <button className="resubmit-btn" onClick={() => handleResubmit(viewdatas.id)}>
                    Resubmit
                  </button>
        <button className="close-btn" onClick={() => setView(false)}>Close</button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default ApproveCertificate;
